import { Dialog, DialogBody, DialogHeader } from "@material-tailwind/react";
import React, { useEffect, useState } from "react";
import { Dots } from "react-activity";
import { useAppDispatch, useAppSelector } from "../../../utils/redux/hooks";
import { addPrivacyPolicy, addisLoading } from "../../../utils/redux/mainSlice";
import {
  addSettingsContent,
  deleteContent,
  getSettingsContentByTitle,
} from "../../../utils/apis/func";
import { RootState } from "../../../utils/redux/store";
import { toast } from "react-toastify";
import { MdDeleteOutline, MdEdit } from "react-icons/md";
import TextEditor from "../../TextEditor";

const SPTermsContent = () => {
  const [newPrivacy, setNewPrivacy] = useState<any>();
  const dispatch = useAppDispatch();
  const fetchChats = async () => {
    dispatch(addisLoading(true));
    const res: any = await getSettingsContentByTitle("SPTerms");
    setNewPrivacy(res?.data?.data);
    console.log("res get privacyPolicay fromdb ", res);
    if (res?.status === 200 || res?.status === 201) {
      dispatch(addPrivacyPolicy(res?.data?.data));
      // setHtml(res?.data?.data?.[0]?.data);
    }

    dispatch(addisLoading(false));
  };
  useEffect(() => {
    fetchChats();
  }, []);

  console.log("New- prvacy", newPrivacy);

  const initialValue: any = {
    title: "",
    body: "",
    tag: "SPTerms",
  };
  const [SPTerms, setSPTerms] = useState(initialValue);

  const handleAddSettings = async (item: any) => {
    setisLoading(true);
    // dispatch(addisLoading(true));
    try {
      const res = await addSettingsContent(item);
      console.log(res);
      toast("Settings Added Successfully", {
        position: "top-right",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "light",
      });
    } catch (error) {
      console.error("Error adding settings:", error);
      toast("Error adding settings", { type: "error" });
    } finally {
      // dispatch(addisLoading(false));
      fetchChats();
      setOpen(false);
      setSPTerms(initialValue);
      setisLoading(false);
    }
  };

  const [selectedItem, setSelectedItem] = useState<any>();

  const [open, setOpen] = React.useState(false);
  const handleOpen = () => setOpen(!open);
  const [openDelete, setOpenDelete] = React.useState(false);
  const handleOpenDelete = () => setOpenDelete(!open);

  const [isLoading, setisLoading] = useState(false);

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const { name, value } = e.target;
    setSPTerms({
      ...SPTerms,
      [name]: value,
    });
  };

  const handleEditClick = (item: any) => {
    // setSelectedItem(item);
    setSPTerms({
      title: item.title,
      body: item.body,
      tag: "SPTerms",
      id: item.id,
    });
    setOpen(true);
  };

  const handleDelete = async (id: any) => {
    setisLoading(true);
    const res: any = await deleteContent(id);
    console.log("delete REs", res);
    console.log("Add Services", res);
    if (res?.status === 200 || res?.status === 201) {
      toast("Content Deleted Successfully", {
        position: "top-right",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "light",
      });
      // setOpen(false);
      setOpenDelete(false);
      fetchChats();
    }
    // dispatch(addisLoading(false));
    setOpenDelete(false);
    setisLoading(false);
  };

  console.log(SPTerms);

  return (
    <>
      <div className="px-3">
        <p className="text-[#000] font-roboto text-2xl font-medium leading-normal mt-4 border-b-2 border-[#000] w-fit px-4">
          Edit Service Provider Privacy Policy
        </p>
      </div>
      <section className="px-2 lg:px-6 mt-6 w-full lg:w-4/5">
        <main className="bg-[#8E8E93] border border-[#88087B] rounded-sm ">
          <div className="flex flex-col">
            <p className="pb-2 font-roboto text-base font-normal leading-5">
              Content:
            </p>
            <div className=" bg-[#fff] rounded-3xl p-4 h-screen overflow-y-auto">
              <div className="text-right">
                <button
                  onClick={() => {
                    setOpen(true);
                  }}
                  className="bg-green-600 py-2 px-4 rounded-md text-white my-3"
                >
                  Add Privacy
                </button>
              </div>
              <div className="space-y-4">
                {newPrivacy?.map((item: any, index: any) => {
                  return (
                    <div
                      className="space-y-4 p-4 border rounded-md"
                      key={index}
                    >
                      <div className="flex justify-end gap-3 my-3">
                        <div
                          className="ml-3"
                          onClick={() => {
                            // setSelectedItem(item);
                            handleEditClick(item);
                          }}
                        >
                          <MdEdit size={24} />
                        </div>
                        <div
                          className="ml-3"
                          onClick={() => {
                            setSelectedItem(item);
                            setOpenDelete(true);
                            // handleDelete(item?.selected)
                          }}
                        >
                          <MdDeleteOutline
                            size={25}
                            className=" cursor-pointer text-[#fff] bg-[#D11C1C] rounded-md p-0.5"
                          />
                        </div>
                      </div>
                      <p className="font-bold">{item?.title}</p>
                      <p dangerouslySetInnerHTML={{ __html: item?.body }} />
                    </div>
                  );
                })}
              </div>
            </div>
          </div>
        </main>
      </section>

      <Dialog open={open} handler={handleOpen}>
        <DialogBody>
          <section className="flex flex-col lg:flex-row w-full  gap-16 px-3 lg:px-6 ">
            <div className="flex flex-col gap-7 w-full  font-roboto text-sm font-normal leading-normal">
              <div className="mb-0">
                <label
                  htmlFor="qst"
                  className="block mb-2 text-sm font-medium text-gray-900 dark:text-white"
                >
                  Title
                </label>
                <input
                  type="text"
                  id="qst"
                  name="title"
                  className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
                  placeholder="Edit Title"
                  required
                  value={`${SPTerms?.title}`}
                  onChange={handleChange}
                />
              </div>
              <div className="mb-0">
                <label
                  htmlFor="qst"
                  className="block mb-2 text-sm font-medium text-gray-900 dark:text-white"
                >
                  Body
                </label>

                <TextEditor
                  value={SPTerms?.body ?? ""}
                  setValue={(htmlText) =>
                    setSPTerms({
                      ...SPTerms,
                      body: htmlText,
                    })
                  }
                />
              </div>
              <div className="px-12 w-full flex justify-center items-center lg:block">
                {isLoading ? (
                  <>
                    <Dots size={40} color="var(--admin-accent)" />
                  </>
                ) : (
                  <button
                    onClick={(e) => {
                      handleAddSettings(SPTerms);
                    }}
                    className="bg-[#88087B] text-[#FFCD1E] text-center text-shadow font-roboto text-lg font-medium leading-normal sm:w-3/4 lg:w-[40%] lg:mx-auto py-2.5 rounded-md mt-4 "
                  >
                    Save Changes
                  </button>
                )}
              </div>
            </div>
          </section>
        </DialogBody>
      </Dialog>
      <Dialog open={openDelete} handler={handleOpenDelete}>
        <DialogHeader>Delete Content</DialogHeader>
        <DialogBody>
          <div className="relative p-4 w-full  max-h-full flex  flex-col">
            <div className="p-4 md:p-5 text-center mx-auto ">
              <svg
                className="mx-auto mb-4 text-gray-400 w-12 h-12 dark:text-gray-200"
                aria-hidden="true"
                xmlns="http://www.w3.org/2000/svg"
                fill="none"
                viewBox="0 0 20 20"
              >
                <path
                  stroke="currentColor"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                  stroke-width="2"
                  d="M10 11V6m0 8h.01M19 10a9 9 0 1 1-18 0 9 9 0 0 1 18 0Z"
                />
              </svg>
              <h3 className="mb-5 text-lg font-normal text-gray-500 dark:text-gray-400">
                Are you sure you want to delete {selectedItem?.title} ?
              </h3>
              <button
                data-modal-hide="popup-modal"
                type="button"
                className="text-white bg-red-600 hover:bg-red-800 focus:ring-4 focus:outline-none focus:ring-red-300 dark:focus:ring-red-800 font-medium rounded-lg text-sm inline-flex items-center px-5 py-2.5 text-center me-2"
                onClick={() => {
                  handleDelete(selectedItem?.id || selectedItem?._id);
                }}
              >
                Yes, I'm sure
              </button>
              <button
                data-modal-hide="popup-modal"
                type="button"
                className="text-gray-500 bg-white hover:bg-gray-100 focus:ring-4 focus:outline-none focus:ring-gray-200 rounded-lg border border-gray-200 text-sm font-medium px-5 py-2.5 hover:text-gray-900 focus:z-10 dark:bg-gray-700 dark:text-gray-300 dark:border-gray-500 dark:hover:text-white dark:hover:bg-gray-600 dark:focus:ring-gray-600"
                onClick={() => {
                  setOpenDelete(false);
                }}
              >
                No, cancel
              </button>
            </div>
            {isLoading && (
              <>
                <Dots size={40} color="var(--admin-accent)" />
              </>
            )}
          </div>
        </DialogBody>
      </Dialog>
    </>
  );
};

export default SPTermsContent;
